import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, memo, useMemo } from 'react';
import { useTheme } from 'styled-components';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';
import { ButtonDisabledContextProvider } from './disabled-context.js';
import { GlowLayer, GlowOrbIndigo, GlowOrbs, GlowOrbSky, GlowScrim } from './glow.styled.js';
import { getVariant } from './helpers.js';
import { ButtonContent, ButtonWrapper, StyledLoader } from './styled.js';
export const Button = memo(forwardRef(function Button({ children, primary, secondary, critical, ghost, reducedGap, glowing, preventDefault, stopPropagation, onClick, dataTestId, ...props }, ref) {
    const { colors } = useTheme();
    const variant = getVariant({ primary, secondary, critical, ghost });
    const isGlowing = !!glowing && variant === 'secondary' && !props.disabled && !props.isLoading;
    const loaderColor = useMemo(() => {
        if (props.disabled)
            return colors.grey100_2;
        if (variant === 'primary' || variant === 'critical')
            return colors.grey00_2;
        if (variant === 'ghost')
            return colors.black_1;
        return colors.black_1;
    }, [variant, colors, props.disabled]);
    const handleClick = useCallbackRef((e) => {
        if (preventDefault) {
            e.preventDefault();
        }
        if (stopPropagation) {
            e.stopPropagation();
        }
        if (!props.isLoading) {
            onClick?.(e);
        }
    });
    return (_jsxs(ButtonWrapper, { type: 'button', variant: variant, $glowing: isGlowing, onClick: handleClick, ref: ref, "data-testid": dataTestId, ...props, children: [isGlowing && (_jsxs(GlowLayer, { children: [_jsxs(GlowOrbs, { children: [_jsx(GlowOrbSky, {}), _jsx(GlowOrbIndigo, {})] }), _jsx(GlowScrim, {})] })), props.isLoading && _jsx(StyledLoader, { content: true, size: '16px', fill: loaderColor }), _jsx(ButtonContent, { $reducedGap: reducedGap, $isLoading: props.isLoading, children: _jsx(ButtonDisabledContextProvider, { disabled: !!props.disabled, children: children }) })] }));
}));
